import { render } from "./touliuBatchOrderModal.vue?vue&type=template&id=4f48fa78&scoped=true"
import script from "./touliuBatchOrderModal.vue?vue&type=script&lang=js"
export * from "./touliuBatchOrderModal.vue?vue&type=script&lang=js"

import "./touliuBatchOrderModal.vue?vue&type=style&index=0&id=4f48fa78&lang=scss&scoped=true"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f48fa78"]])

export default __exports__